import { ListItem, ListItemText } from "@mui/material";

import { createMechanicalTimeStr } from "@/shared/components/actions/invocation/InvocationRuntimeText/helpers";
import { InvocationStatus } from "@/shared/domain/actions";

interface InvocationRuntimeText {
  duration: string;
  lastStatus: InvocationStatus;
}

export function InvocationRuntimeText({
  duration,
  lastStatus,
}: InvocationRuntimeText) {
  const mechanicalTimeStr = createMechanicalTimeStr(duration);
  const showRuntime = lastStatus === InvocationStatus.Completed;
  return (
    <div>
      {showRuntime && (
        <ListItem>
          <ListItemText primary={"Duration"} secondary={mechanicalTimeStr} />
        </ListItem>
      )}
    </div>
  );
}
